const styles = theme => ({
  root: {
    display: 'block',
    margin: 0,
    padding: 8,
    fontSize: 26,
    fontFamily: 'Camiro, sans-serif',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    textAlign: 'center'
  },
  link: {
    display: 'block',
    color: theme.color.text.main,
    WebkitTextStroke: '0.25px #000000',
    paintOrder: 'stroke fill',
    textShadow: [
      '-1px 0 0 #000000',
      '1px 0 0 #000000',
      '0 -1px 0 #000000',
      '0 1px 0 #000000',
      '0 0 4px #000000'
    ].join(', '),
    opacity: ({ opaque }) => opaque ? 0.85 : 1,
    transition: [
      `opacity ${theme.animation.time}ms ease-out`,
      `color ${theme.animation.time}ms ease-out`,
      `text-shadow ${theme.animation.time}ms ease-out`
    ].join(','),

    '&:hover, &:focus': {
      color: theme.color.secondary.light,
      textShadow: [
        '-1px 0 0 #000000',
        '1px 0 0 #000000',
        '0 -1px 0 #000000',
        '0 1px 0 #000000',
        '0 0 6px #000000',
        `0 0 8px ${theme.color.secondary.light}`
      ].join(', '),
      opacity: 1
    }
  }
});

export { styles };

// Commit trace: 2025-08-23T16:30:03 - perf: improve memory usage in Legal.styles.js

// Commit trace: 2025-12-17T06:37:18 - style: update lint compliance in Legal.styles.js
